<template>
    <div class="anchor">
      <div class="back global_pointer" @click="goBack">
          <img src="@/assets/imgs/back_white.png"/>
      </div>
        <Brief :anchor-info="anchorInfo" :storeName="storeName" :storeInfo="storeInfo" />
        <!-- <div class="anchor-related">
          <Related class="related" :type="1" :relateData="inviteHost" :title="$t('message.anchor.hosts')"/>
          <Related class="related" :type="2" :relateData="hostStoreList" :title="$t('message.anchor.brands')"/>
        </div> -->
        <van-divider v-if="inviteHost.length || hostStoreList.length" class="anchor-divider"/>
        <div class="products-shows">
          <van-tabs
            v-model="active"
            line-width="20px"
            color="rgb(57,210,214)"
            title-active-color="rgb(57,210,214)"
            title-inactive-color="rgb(153,153,153)"
            background="#1d1d1d"
            >
            <van-tab
              v-for="item in vantab"
              :key="item.name"
              :title="item.title"
              :name="item.name"
              title-style="font-family:'TradeGothicLT-Bold'">
              <component v-if="anchorInfo.id && storeInfo.id" :is="item.components" :store-info="storeInfo" :anchor-info="anchorInfo" :play-back-list="playBackList"></component>
            </van-tab>
          </van-tabs>
        </div>
    </div>
</template>

<script>
import api from "@/api/api_list";
import Brief from '@/components/anchor/brief';
import Related from '@/components/anchor/related'
import PlayBack from '@/components/anchor/playBack';
import { Tab, Tabs, Divider } from 'vant';
import Prodects from '@/components/anchor/prodects'

export default {
    name: 'Anchor',
    components: {
        Brief,
        Related,
        // Live,
        PlayBack,
        Prodects,
        // NavBar,
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        [Divider.name]: Divider
    },
    mixins: [],
    data() {
        return {
            active: 'shows',
            vantab: [

                {
                    title: this.$t('message.anchor.shows'),
                    name: 'shows',
                    components: 'PlayBack'
                },
                {
                    title: this.$t('message.anchor.goodsTitle'),
                    name: 'goods',
                    components: 'prodects'
                },
            ],
            anchorInfo: {},
            inviteHost: [],
            hostStoreList: [],
            liveList: [],
            playBackList: [],
            // hostId: '5a9f29b2b4f73994018b45f1',
            hostId: '',
            playBackPager: {
                pageNum: 0, // 当前页数
                pages: null, // 总页数
                total: null, // 总条数
            },
            storeName: '',
            storeInfo: {},
            // hostId: '5d4a9b025222c5001f06ca02',
        };
    },
    mounted() {
        const { hostId } = this.$route.query;
        this.hostId = hostId;
        this.init();
    },
    methods: {
         goBack() {
            this.$router.back(-1)
        },
        async init() {
            try {
                // await this.getAnchorInfos();
                await this.getHostStore();
                await this.getHostInviteHost();
                // await this.getHostStoreDetail();
                Promise.all([
                    this.getAnchorInfos(),
                    this.getHostStoreDetail()
                ])
            } catch (e) {
                console.error(e);
            } finally {
            }
        },
        share() {
            // shareUrl({
            //     url: location.href + '&authLogin=true',
            //     ...this.anchorInfo
            // })
        },
        // 主播简介
        async getAnchorInfos() {
            const params = {
                hostId: this.hostId
            }
            const anchor = await api.get_host_userinfo(params);
            const rst = anchor.result || {};
            // 是否有简介信息
            const hasBrief = rst.shoulder || rst.height || rst.weight || rst.chest || rst.waist || rst.hipline || rst.shoesize
            rst.hasBrief = Boolean(hasBrief);
            this.anchorInfo = rst;
        },
        async getHostStoreDetail() {
            try {
                const { result } = await api.get_host_store(
                    {
                        hostId: this.hostId
                    }
                )
                this.storeInfo = result
                this.storeName = result.nameZh
            } catch(e) {
                console.log(e)
            }
        },
        // 直播、预告
        // 播过的品牌
        async getHostStore() {
            try {
                const { code, result } = await api.get_host_played_store({
                    hostId: this.hostId
                })
                if (code) return
                this.hostStoreList = result
            } catch(e) {
                console.log(e)
            }
        },
        // 主播邀请过的主播列表
        async getHostInviteHost() {
            try {
                const { code, result } = await api.host_invite_hosts({
                    hostUserId: this.hostId,
                    pageSize: 15,
                    pageNum: 1
                })
                if (code) return
                this.inviteHost = result
            } catch(e) {
                console.log(e)
            }
        },
        async getLiveList(){
            try {
                const params = {
                    hostId: this.hostId
                }
                const rst = await api.get_host_livelist(params);
                this.liveList = rst.result || [];
            } catch(e) {
                /*global window*/
                window.__bl && window.__bl.error(`获取直播预告错误：${JSON.stringify(e)}`);
            }
        },
        // 回放
        async getPlayBack() {
            try {
                const pageNum = this.playBackPager.pageNum + 1;
                const params = {
                    hostId: this.hostId,
                    pageNum,
                    pageSize: 5,
                }
                const rst = await api.get_host_playback(params);
                const pageObj = rst.result || {}
                this.playBackPager = {
                    pages: pageObj.pages,
                    total: pageObj.total,
                    pageNum
                }
                const playBackList = this.playBackList || []
                this.playBackList = playBackList.concat(pageObj.data || []);
            } catch(e) {
                /*global window*/
                window.__bl && window.__bl.error(`获取回放错误：${JSON.stringify(e)}`);
            }
        },
        liveRemind(id) {
            this.liveList.find(item => item.id === id).remindStatus = 1;
        },
        liveCancelRemind(id) {
            this.liveList.find(item => item.id === id).remindStatus = 0;
        }
    }
}
</script>
<style scoped lang="less">
    .anchor{
        background-color: #000000;
        height: 100%;
        &-top{
            width: 375px;
            height: 170px;
            background: #fff url('https://fr-static.shopshops.top/20200915/header_bg.352cf5e1713c824b.jpg') no-repeat left bottom;
            background-size: contain;
        }
        &-body{
            position: relative;
        }
        &-related{
          padding-bottom: 20px;
          background: rgb(29,29,29);
          .related{
            padding-top: 20px;
          }
        }
        .anchor-divider{
            border-color: #ffffff;
             opacity: .95;
             margin: 0 12px;
        }
        .tab-text{
            font-family: "TradeGothicLT-Bold";
        }
        .back{
        img{
            width: 40px;
            height: 40px;
        }
          position: fixed;
            top: 85px;
            left: 15px;
            width: 40px;
            height: 40px;
            z-index: 100;
            
            }
    }

</style>
